import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { RevokeApprovalRequestInput } from '@erp/rpc';
import { useToast } from '@/context/ToastContext';

export function useRevokeApprovalRequest() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async (input: RevokeApprovalRequestInput) => {
      return await rpcClient.finance.payments.revokeApprovalRequest(input);
    },
    onSuccess: (_, { paymentId }) => {
      showToast({
        title: 'Approval Request Revoked',
        message: 'Approvers have been notified. You can now edit the payment.',
        color: 'success',
        icon: 'check',
      });

      void queryClient.invalidateQueries({
        queryKey: orpc.finance.payments.get.queryKey({
          input: { id: paymentId },
        }),
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.finance.payments.get.queryKey({
          input: { id: paymentId, includeProviderDetails: true },
        }),
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.finance.payments.list.queryKey({ input: {} }),
      });
    },
    onError: (error) => {
      showToast({
        title: 'Error',
        message: error.message || 'Failed to revoke approval request',
        color: 'error',
        icon: 'x',
      });
    },
  });
}
